<template>
  <div class="activity-warp">
    <div class="activity-head">
      <img class="backicon" src="../../assets/imgs/close.png" @click="onBack">
      <div class="activity-title">{{i18nActivation.activation}}</div>
    </div>
    <div style="display: none">
      <img class="banner" src="../../assets/imgs/loginbanner.png">
      <div class="welcome">{{i18nActivation.welcome}}</div>
      <div class="content">
        {{i18nActivation.hello}}, <br>{{i18nActivation.thank}}
      </div>
    </div>
    <div>
      <div class="bind-box">
        <div class="device-no">{{i18nActivation.device_sn}}:</div>
        <van-field type="text" v-model="deviceSn" class="device-input" :use-right-icon-slot = 'true'>
          <template #right-icon >
            <van-image :src="require('assets/imgs/icon_Scan.png')" width="2em" height="2em" @click="scanQr"></van-image>
          </template>
        </van-field>
      </div>
      <div class="method" @click="show = true">{{i18nActivation.viewing_methods}}</div>
      <div class="bind-box" >
        <div class="device-no">{{i18nActivation.mail}}</div>
        <van-field type="email" :disabled="!isSHowCode" v-model="email" class="device-input" ></van-field>
      </div>

      <div class="bind-box" v-if="isSHowCode">
        <div class="device-no">{{i18nActivation.code}}:</div>
        <van-field v-model="code"  class="device-input" >
          <template #button>
            <div class="login-code" @click="onCaptcha">
              <img :src="captchaUrl" />
            </div>
          </template>
        </van-field>
      </div>
      <div class="bind-box" v-if="isSHowCode">
        <div class="device-no">{{i18nActivation.verification_code}}:</div>
        <van-field v-model="verifyCode"  class="device-input" >
          <template #button>
            <van-button size="small" class="send-btn" type="primary" @click="onSendCode">{{send}}</van-button>
          </template>
        </van-field>
      </div>
    </div>
    <div class="activity-foot">
      <button class="activation-btn" :disabled="checkDisabled" :style="checkDisabled? 'background: #E1E1E1;' :'background: #036EB8;'" @click="toBind">{{i18nActivation.binding}}</button>
      <div class="go-home" @click="backHome">
        <img src="../../assets/imgs/go_back_home.png" @click="onBack">
        <label class="content">{{i18nActivation.back_to_home}}</label>
      </div>
    </div>
    <van-dialog v-model="show" title="" :show-cancel-button="false" :show-confirm-button="false" width="380px">
      <van-icon name="cross" class="cross-btn" @click="show = false" />
      <div class="package-title">
        {{i18nActivation.viewing_methods}}
      </div>
      <div class="method-box">
        <van-image :src="require('assets/imgs/mifi-back.png')" width="105px"></van-image>
        <van-image :src="require('assets/imgs/mifi_back02.png')" class="method-img-r" ></van-image>
        <div class="method-label">{{i18nActivation.scan_the_qr_code}}</div>
      </div>
    </van-dialog>
    <div class="fixed" v-if="isPickUpShow" @click="isPickUpShow = false">
      <ScanQr @scanQr="onScanQr" />
    </div>
    <div style="position: fixed;right: 20px;bottom: 15%;">
      <a href="whatsapp://send?phone=+15360129730">
        <img src="../../assets/imgs/contactus/icon_whatsapp.png" alt="" height="40px" width="40px">
      </a>
    </div>
  </div>
</template>

<script>
import { baseURL } from '../../utils/http'
import { USER_CAPTCHA, SEND_CODE, USER_INFO } from '../../apis/user'
import ScanQr from 'views/scanQr/scanQr.vue'
import { mapState } from 'vuex'
import { generateUUID } from '@/utils'
import { MIFI_BIND, MIFI_PICKUP, MIFI_QR_CODE } from '@/apis/cabinet'
import { WECHAT_MP_PRE_PAY } from '@/apis/payment'
export default {
  components: {
    ScanQr
  },
  computed: {
    ...mapState(['user', 'browser', 'system']),
    i18n () {
      return this.$t('login')
    },
    i18nActivation() {
      return this.$t('activation')
    }
  },
  watch: {
    user (val, oldVal) {
      if (val && !oldVal) {
        this.$router.push('/')
      }
    }
  },
  data () {
    return {
      phone: '',
      show: false,
      captchaUrl: '',
      email: '',
      sn: '',
      verifyCode: '',
      code: '',
      isPickUpShow: false,
      deviceSn: '',
      isSHowCode: true,
      send: 'Send',
      disabled: false,
      count: 59,
      timer: null,
      checkDisabled: true
    }
  },
  methods: {
    onBack () {
      this.$router.go(-1)
    },
    toBind () {
      this.$loading(true)
      let url = `${MIFI_BIND}?email=${this.email}&deviceSn=${this.deviceSn}&verifyCode=${this.verifyCode}`
      this.$post(url, {
        }, res => {
          this.$loading(false)
          if (res.token) {
            this.$store.commit('token', res.token)
            this.loadUser()
          }
          this.$router.go(-1)
        //  this.$router.push("/deviceManager")
        },
        err => {
          this.$loading(false)
          this.$toast(err)
          this.onCaptcha()
        },
        {
          headers: {
            // agentOpenId: !this.isProd ? 'oDn2e4hi8M1iVtXcxm1uYpKTPEBE' : ''
            agentOpenId: 'oDn2e4hi8M1iVtXcxm1uYpKTPEBE' // 正式
          }
        }
      )
    },
    onSendCode() {
      this.$loading(true)
      let url = `${SEND_CODE}?email=${this.email}&uuid=${this.uuid}&code=${this.code}`
      this.$post(url, {}, res => {
          this.$loading(false)
          this.disabled = true
          this.startCountdown();
          this.checkDisabled = false
        },
        err => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
          this.onCaptcha()
        },
        {
          headers: {
            // agentOpenId: !this.isProd ? 'oDn2e4hi8M1iVtXcxm1uYpKTPEBE' : ''
            agentOpenId: 'oDn2e4hi8M1iVtXcxm1uYpKTPEBE' // 正式
          }
        }
      )
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.count > 0) {
          this.count -= 1;
          this.send = this.count + 's'
        } else {
          this.disabled = false
          this.send = 'Send'
          this.clearCountdown();
        }
      }, 1000);
    },
    clearCountdown() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    onCaptcha () {
      this.code = ''
      this.uuid = generateUUID()
      this.captchaUrl = `${baseURL}${USER_CAPTCHA}?uuid=${this.uuid}`
    },
    scanQr() {
      this.isPickUpShow = true
     //  this.$post(MIFI_QR_CODE,
     //    {
     //      url: encodeURIComponent('https://wifi.chargenow.top/#/?qr=1713928951')
     //    },
     //    resp => {
     //      this.deviceSn = resp.data
     //    }
     //  )
    },
    onScanQr(qr) {
      this.isPickUpShow = false
      this.onScan(qr)
    },
    onScan(urlcode) {
      this.$post(MIFI_QR_CODE,
        {
          url: encodeURIComponent(urlcode)
        },
        resp => {
          this.deviceSn = resp.data
        }
      )
    },
    loadUser () {
      this.$get(
        USER_INFO,
        {},
        res => {
          this.$loading(false)
          if (res.user) {
            this.$store.commit('user', res.user)
            this.$toast(this.i18n.msg_success_login)
          }
        },
        err => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
            this.$store.commit('token', null)
          })
        }
      )
    },
    backHome() {
      this.$router.push('/')
    }
  },
  created () {
    var user = this.user;
    if (user != null && user.email) {
      this.email = user.email
      this.isSHowCode = false
      this.checkDisabled = false
    }
  },
  mounted () {
    this.onCaptcha()
  }
}
</script>

<style lang="less" scoped>
.activity-warp {
  height: 100vh;
 // background: linear-gradient(#00AB46, #1A2229);
  .activity-head{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    .backicon{
      width: 50px;
    }
    .activity-title{
      text-align: center;
      width: 100%;
      font-family: Montserrat, Montserrat;
      font-weight: bold;
      font-size: 36px;
      color: #1A2229;
    }
  }
  .welcome{
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 56px;
    color: #333333;
    width: 90%;
    margin: 40px auto 0;
  }
  .content{
    font-family: Montserrat, Montserrat;
    font-weight: 500;
    font-size: 30px;
    color: #333333;
    width: 90%;
    margin: 40px auto 0  ;
  }
  .banner{
    width: 65%;
    display: block;
    margin: 50px auto;
  }
  .logowhite{
    width: 15%;
    display: block;
    margin: 0 auto;
  }
  .activity-foot {
    width: 90%;
    margin: 40px auto 0;
    .appleloginbtn2{
      width: 100%;
      border: none;
      background: #fff;
      color: #000;
      margin: 40px 0 0;
      img{
        width: 50px;
        margin-right: 20px;
      }
    }
    .foot-bottom{
      bottom: 0;
      position: absolute;
      left: 0;
      right: 0;
      text-align: center;
    }
    .appleloginbtn{
      width: 100%;
      border: none;
      background: #fff;
      color: #000;
      img{
        width: 60px;
        margin-right: 20px;
      }
    }
    .otherlogin{
      width: 100%;
      border: none;
      background: #00AB46;
      color: #fff;
      margin: 40px 0 0;
    }
    &-imgs {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .activation-btn{
      font-family: Montserrat, Montserrat;
      font-weight: bold;
      font-size: 40px;
      color: #FFFFFF;
      border: none;
      width: 670px;
      height: 98px;
      border-radius: 50px 50px 50px 50px;
    }
    .go-home{
      text-align: center;
      width: 100%;
      margin: 21px auto;
      img{
        width: 34px;
        height: 34px;
        vertical-align: -5px;
        display: inline-block;
      }
      .content{
        font-family: Montserrat, Montserrat;
        font-weight: 400;
        font-size: 28px;
        color: #036EB8;
        margin-top: -3px;
      }
    }
  }
  .bind-box{
    padding: 20px;
  }
  .device-no{
    font-family: MyFont3;
    font-weight: bold;
    font-size: 30px;
    color: #1A2229;
  }
  .device-input{
    width: 100%;
    height: 90px;
    background: #FFFFFF;
    border-radius: 49px 49px 49px 49px;
    border: 2px solid #D1D1D1;
    margin-top: 20px;
  }
  .method{
    text-align: center;
    font-family: MyFont2;
    font-weight: 400;
    font-size: 28px;
    color: #036EB8;
    padding-top: 28px;
  }
  .send-btn{
    border: none;
    background: #ffffff;
    color: #036EB8;
    font-size: 26px;
  }
}
.package-title{
  text-align: center;
  padding: 30px 40px 30px 40px;
  font-family: MyFont2;
  color: #333333;
  font-weight: bold;
  font-size: 36px;
}
.cross-btn{
  position: absolute;
  right: 30px;
  top: 30px;
  font-size: 40px;
}
.method-img-r{
  position: absolute;
  margin-left: 85px;
  width: 244px;
}
.method-box{
  padding: 20px 20px 40px 20px;
  .method-label{
    font-family: Montserrat, Montserrat;
    font-weight: 400;
    font-size: 22px;
    color: #333333;
    width: 4.2rem;
    margin-left: 3.5rem;
    margin-top: -1.3rem;
  }
}
.login-code {
  img {
    width: 180px;
    height: 60px;
    border: none;
    margin-top: -3px;
  }
}
.activity-foot {
  width: 90%;
  margin: 40px auto 0;
  bottom: 0;
  position: absolute;
  left: 0;
  right: 0;
  .activation-btn{
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 40px;
    color: #FFFFFF;
    border: none;
    width: 670px;
    height: 98px;
    background: #036EB8;
    border-radius: 50px 50px 50px 50px;
    margin-top: 49px;
  }
  .go-home{
    text-align: center;
    width: 100%;
    margin: 21px auto;
    img{
      width: 34px;
      height: 34px;
      vertical-align: -5px;
      display: inline-block;
    }
    .content{
      font-family: Montserrat, Montserrat;
      font-weight: 400;
      font-size: 28px;
      color: #036EB8;
      margin-top: -3px;
    }
  }
}
.fixed{
  position: fixed;
  bottom: 0;
  width: 100%;
  // background: rgba(45, 45, 45, 0.5);
  height: 100%;
}
</style>
